import {
  LOAD_COMMON_HEADERS,
  PARTNER_REGISTRATION_EMAIL_INVALID,
  PARTNER_REGISTRATION_REGISTERED_COMPANIES,
  PARTNER_REGISTRATION_STATUS,
  SET_PROGRAM_TYPE,
  SET_ERROR_CODE,
  SET_USER_LOGGED_IN,
  SET_IMS_PROFILE_EXISTS,
  SET_PARTNER_REGISTRATION_FORM_STEP,
  SET_SELECTED_REGISTER_COMPANY_TYPE,
  SET_DXP_USER_PROFILE_DRAFT,
} from "./actionTypes";
import { getPartnerRegistrationTemplate } from "../Services/PartnerRegistrationAPI";

const showInvalidEmailMessage = (isInvalidEmail: any) => (dispatch: any) => {
  dispatch({
    type: PARTNER_REGISTRATION_EMAIL_INVALID,
    payload: { isInvalidEmail },
  });
};

const setRegisteredCompanies =
  (registeredCompanies: any, currentStep: any) => (dispatch: any) => {
    dispatch({
      type: PARTNER_REGISTRATION_REGISTERED_COMPANIES,
      payload: { registeredCompanies, currentStep },
    });
  };

const setPartnerRegistrationStatus =
  (status: any, stepNumber: any) => (dispatch: any) => {
    dispatch({
      type: PARTNER_REGISTRATION_STATUS,
      payload: { status, stepNumber },
    });
  };

const loadCommonHeaders =
  (programType: string, appType?: string) => async (dispatch: any) => {
    const response: any = await getPartnerRegistrationTemplate(
      appType
        ? `${programType}-common-json-headers-old`
        : `${programType}-common-json-headers`,
    );
    const templateData = response?.data?.formData || {};
    if (response?.status === 200 && Object.keys(templateData).length > 0) {
      dispatch({
        type: LOAD_COMMON_HEADERS,
        payload: { data: templateData, statusCode: 200 },
      });
    } else {
      dispatch({
        type: SET_ERROR_CODE,
        payload: { data: undefined, statusCode: response?.status },
      });
    }
  };

const setProgramType = (programTypeName: string) => (dispatch: any) => {
  dispatch({
    type: SET_PROGRAM_TYPE,
    payload: { programTypeName },
  });
};

const setUserLoginStatus = (loginStatus: any) => (dispatch: any) => {
  dispatch({
    type: SET_USER_LOGGED_IN,
    payload: { loginStatus },
  });
};

const setImsProfileExists = (imsProfileExists: any) => (dispatch: any) => {
  dispatch({
    type: SET_IMS_PROFILE_EXISTS,
    payload: { imsProfileExists },
  });
};

const setPartnerRegistrationFormStep = (stepNumber: any) => (dispatch: any) => {
  dispatch({
    type: SET_PARTNER_REGISTRATION_FORM_STEP,
    payload: { stepNumber },
  });
};

const setSelectedRegisterCompanyType =
  (companyType: any) => (dispatch: any) => {
    dispatch({
      type: SET_SELECTED_REGISTER_COMPANY_TYPE,
      payload: { companyType },
    });
  };

const setDxpUserProfileDraft =
  (draft: Record<string, unknown> | null) => (dispatch: any) => {
    dispatch({
      type: SET_DXP_USER_PROFILE_DRAFT,
      payload: { draft },
    });
  };

export {
  showInvalidEmailMessage,
  setRegisteredCompanies,
  setPartnerRegistrationStatus,
  loadCommonHeaders,
  setProgramType,
  setUserLoginStatus,
  setImsProfileExists,
  setPartnerRegistrationFormStep,
  setSelectedRegisterCompanyType,
  setDxpUserProfileDraft,
};
